import React from 'react'
import styles from './group-item.styles'
import injectSheet from 'react-jss'
import Checkbox from 'pobble-components/dist/form-elements/form-checkbox'

const GroupItem = ({ classes, title, students, onChange, checked }) => (
  <div className={classes.groupItem}>
    <label className={classes.label}>
      <Checkbox
        checked={checked}
        onChange={onChange}
        className={classes.checkbox}
      />
      {title}{' '}
      <span className={classes.studentsNumber}>{students} students</span>
    </label>
  </div>
)

export default injectSheet(styles)(GroupItem)
